<script>
  import options from './MemberListOverlayFrivillig.options'
  export default options
</script>

<template>
  <div class="kb-overlay-styles__content-wrapper" ref="overlayRef">

    <article class="kb-overlay-styles kb-member-list-overlay kb-member-list-overlay-fvl" :class="{ 'kb-member-list-overlay--submitting': isSubmitting }">

      <div class="kb-overlay-styles__wrapper-for-scroll-bottom">

        <div class="kb-overlay-styles__hero">
          <div class="kb-overlay-styles__hero-wrapper kb-overlay-styles__hero-wrapper--member-list">
            <h2 class="kb-member-list-overlay__title">
              {{ getLabel('accordionTitle', [memberCount ?? 0]) }}
            </h2>
          </div>
        </div>

        <div class="kb-overlay-styles__hero-curve">
          <svg role="presentation" viewBox="0 0 720 77" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0V42.4078C238.547 71.2459 479.584 82.0555 720 74.8278V0H0Z" />
          </svg>
        </div>

        
        <div class="kb-overlay-styles__content-wrapper--member-list">

          <div class="kb-member-list-overlay-fvl__mail-to-link">
            <!-- <a :href="getLabel('mailToLinkUrl')">{{getLabel("mailToLinkText")}}</a> -->
          </div>

          <template v-for="(member, index) in members" :key="index">
            <div class="kb-member-list-overlay">
              <h3 class="kb-member-list-overlay__member">

                <svg role="presentation" viewBox="0 0 705 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M705 1H2a1 1 0 0 0-1 1v9" stroke="#BFBFB7" />
                </svg>

                <div class="kb-member-list-overlay-fvl__member-wrapper-toggle">

                  <button class="kb-member-list-overlay-fvl__member-wrapper"
                  :id="`acc-member${member.frivilligprofilId}`" 
                  :aria-controls="`acc-content${member.frivilligprofilId}`" 
                  aria-expanded="false"
                  @keydown.tab="tabTrap"
                  v-on:click="toggleAccordion">
                  
                    <figure class="kb-image-module kb-image-module--1-1 kb-member-list-overlay__member-profile-img">
                      <div class="kb-image-module__image-container">
                        <picture class="kb-image-module__image">
                          <img :src="member.imageSource" :alt="member.imageAlt" />
                        </picture>
                      </div>
                    </figure>
  
                    <p class="kb-member-list-overlay__member-name">
                      {{ member.memberName }}
                      <div class="kb-member-list-overlay__member-roles-wrapper">
                          <span class="kb-member-list-overlay__member-role">
                            {{ getRolleText(member.roller) }}
                          </span>
                      </div>
                    </p>
                    
                    <div class="kb-member-list-overlay__member-chevron kb-ui-icon kb-ui-icon--ui-chevron-down"></div>

                  </button>
                
                </div>

              </h3>
              <div class="kb-member-list-overlay__content" :id="`acc-content${member.frivilligprofilId}`" role="region"
                :aria-labelledby="`acc-member${member.frivilligprofilId}`">

                <section v-if="member.phone || member.email" class="kb-member-list-overlay__content-member-contact">
                  <div v-if="member.phone" class="kb-member-list-overlay__content-member-contact__phone">
                      <div class="kb-ui-icon kb-ui-icon--ui-phone"></div>
                      <a :href="'tel:' + member.phone?.replace(/\s/g, '')">
                          {{ member.phone }}
                      </a>
                  </div>
                  <div v-if="member.email" class="kb-member-list-overlay__content-member-contact__email">                    
                      <div class="kb-ui-icon kb-ui-icon--ui-laptop"></div>
                      <a :href="'mailto:' + member.email">
                          {{ member.email }}
                      </a>
                  </div>
                </section>

                <section class="kb-member-list-overlay__content-member-details">
                  <p class="kb-member-list-overlay__content-member-details-profile-text">{{ member.profileText }}</p>
                  <div class="kb-member-list-overlay__content-member-details-actions-wrapper">
                    <a v-if="canMessage" :href="member.answerLink" class="kb-button kb-button--full-color"> {{ getLabel('writeMessageButtonText') }}</a>
                    <button v-if="canRemove" class="kb-button kb-button--full-color-spot kb-member-list-overlay-fvl__delete-member" @click="handleRemoveMember(member.frivilligprofilId)">
                        {{ getLabel("removeMemberButtonText") }}
                    </button>
                  </div>
                </section>
              </div>
            </div>
          </template>
          <div class="kb-member-list-overlay-fvl__actions-wrapper">
            <div class="kb-member-list-overlay-fvl__show-more" v-if="hasMore">
              <button class="kb-button kb-button--full-color-spot" @click="loadMore()" @keydown.tab="tabTrap">
                  {{ getLabel("showMoreButtonText") }}
              </button>          
            </div>
          </div>

          <template v-if="isSubmitting">
            <div class="kb-spinner-overlay">
              <div class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky"></div>
            </div>
          </template>
        </div>
      </div>
    </article>
  </div>
</template>
